import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { languages, loadLanguage, supportedLanguages } from './languages/languages';

// Build initial resources with only English (other languages loaded on demand)
export const resources = Object.entries(languages).reduce(
  (acc, [lang, translation]) => ({ ...acc, [lang]: { translation } }),
  {}
);

// Track which languages have been loaded
const loadedLanguages = new Set(['en']);

// Load a language dynamically and add it to i18n resources
export const loadLanguageResources = async (lang) => {
  if (loadedLanguages.has(lang)) return true;
  if (!supportedLanguages.includes(lang)) return false;

  const translations = await loadLanguage(lang);
  if (translations) {
    i18n.addResourceBundle(lang, 'translation', translations, true, true);
    loadedLanguages.add(lang);
    return true;
  }
  return false;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      lookupLocalStorage: 'language'
    },
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false
    },
    saveMissing: true,
    missingKeyHandler: (ng, ns, key, fallbackValue) => {
      //console.error(`Key not found ${key}, ${ng}, ${ns}, ${fallbackValue}`);
    },
    fallbackLng: ['en', 'es']
  });

export default i18n;
